export default __webpack_public_path__ + "static/media/share-2.991e82a3.svg";